import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">丝袜小说精选合集</h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              汇聚海量精品原创丝袜小说，涵盖都市言情、青春校园、职场情感等多元题材，每日更新最新章节，为喜爱丝袜小说的读者提供极致阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">分类导航</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-accent-300 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-secondary-300 hover:text-accent-300 transition-colors duration-200"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-300 hover:text-accent-300 transition-colors duration-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-accent-300 transition-colors duration-200">
                  读者须知
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-accent-300 transition-colors duration-200">
                  版权声明
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-accent-300 transition-colors duration-200">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['都市言情', '青春校园', '职场情感', '悬疑推理', '古风言情', '现代都市', '浪漫爱情', '成长故事'].map(
                (tag) => (
                  <span
                    key={tag}
                    className="text-xs px-2 py-1 rounded-md bg-secondary-800 text-secondary-300 cursor-pointer hover:bg-secondary-700 transition-colors duration-200 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                )
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 丝袜小说精选合集 版权所有 | 本站内容仅供阅读交流，请支持正版
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-400 hover:text-accent-300 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-accent-300 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-accent-300 transition-colors duration-200" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}